import IAccount from 'types/IAccount';

export interface IWorkflowUserName {
  name: string;
  isAccountWorker: boolean;
}

interface IUserLike {
  given_name?: string;
  family_name?: string;
  username?: string;
}

export default function formatWorkflowUser(
  userId: string,
  user: IUserLike | undefined,
  account: IAccount | undefined,
): IWorkflowUserName {
  if (user) {
    const fullName = [user.given_name, user.family_name].filter(Boolean).join(' ').trim();
    return { name: fullName || user.username || userId, isAccountWorker: false };
  }

  if (account) {
    return { name: account.organization_name || userId, isAccountWorker: true };
  }

  return { name: userId, isAccountWorker: false };
}
